import { config } from 'affiny-core/env';
import { getPaymentWebviewUrl } from 'affiny-core/modules/api/repositories/payment/payment.sagas';
import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { ActionsOfType } from 'affiny-core/modules/helpers';
import { all, call, takeLatest } from 'redux-saga/effects';
import {
  EGoToRateCardActionType,
  IGoToRateCardAction,
} from '../actions/goToRatecardActions';

export function* goToRateCardSaga(
  action: ActionsOfType<IGoToRateCardAction, EGoToRateCardActionType.GO_TO>
) {
  const { origin } = config.env;
  /* BEGIN: Preprod hack
Explanation: Payment team on a security issue has filtered the origin of returnUrlOk and returnUrlKo for apixl but not for juno.
So, we call payment with prod parameters.
Result: We can go to the payment page, but if we come back by back button, we comes back in production.
This hack could be removed when we don't use preprod anymore */
  const rewritedOrigin = origin?.replace('.pprod', '');
  /* END: Preprod hack */
  const { returnRouteOk, returnRouteKo, actionCode } = action.payload;
  const { url: rateCardUrl } = yield call(getPaymentWebviewUrl, {
    actionCode,
    returnUrlOk: `${rewritedOrigin}${returnRouteOk}`,
    returnUrlKo: `${rewritedOrigin}${returnRouteKo}`,
  });

  yield call(action.payload.redirectToExternalLink, rateCardUrl);
}

export function* rateCardRootSaga() {
  yield all([
    takeLatest(
      EGoToRateCardActionType.GO_TO,
      handleAsyncStatus(goToRateCardSaga, EAsyncEventTypes.GO_TO_RATE_CARD)
    ),
  ]);
}
